// import ReactDOM from "react-dom";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n/config.js";

const root = createRoot(document.getElementById("aubin"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
